var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    stroke: "#D4D4D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6266 9.33351C10.6265 9.68713 10.4858 10.0262 10.2356 10.2761C9.98546 10.526 9.64625 10.6664 9.29263 10.6662C8.93901 10.666 8.59994 10.5254 8.35001 10.2752C8.10009 10.025 7.95978 9.6858 7.95996 9.33218C7.96014 8.97856 8.10078 8.63949 8.35096 8.38956C8.60113 8.13964 8.94034 7.99934 9.29396 7.99951C9.64758 7.99969 9.98665 8.14033 10.2366 8.39051C10.4865 8.64068 10.6268 8.97989 10.6266 9.33351ZM10.6666 11.6535H7.99996V20.0002H10.6666V11.6535ZM14.88 11.6535H12.2266V20.0002H14.8533V15.6202C14.8533 13.1802 18.0333 12.9535 18.0333 15.6202V20.0002H20.6666V14.7135C20.6666 10.6002 15.96 10.7535 14.8533 12.7735L14.88 11.6535Z",
    fill: "#D4D4D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f63648dddb152e45503bc1f293c220b1.svg";
export { ForwardRef as ReactComponent };